import moment from 'moment';
import {
  GetLatestDuOrderLog,
  GetLatestLpaOrderLog,
  GetLastRunDate,
  GetDuStatusHtml,
  AusResult,
  GetLpaStatusHtml,
  LpaResult,
  OrderLogModel,
  GetDuEaStatusHtml,
  GetLatestDuEaOrderLog,
} from '../../aus/models';
import { AusModel, InvalidControlModel, LoanDataModel, MortgageType } from '../../cmg-1003/models';
import { ILoanStatusCard, LoanStatusCardConfig, LoanStatusCardType } from './loan-status-card.model';
import { BusinessChannel } from '../../models';

export const GetAusStatus = (
  ausPanelHasBeenOpened: boolean,
  aus: AusModel,
  loanInfo: LoanDataModel,
  validations: InvalidControlModel[],
  businessChannel: BusinessChannel,
  isSandboxLoan: boolean,
  isShowSandboxLoanLpa: boolean,
): ILoanStatusCard => {
  const cardBase = LoanStatusCardConfig.find((c) => c.cardType === LoanStatusCardType.AUS);
  const card = { ...cardBase, cardType: LoanStatusCardType.AUS } as ILoanStatusCard;
  const isUSDALoan = loanInfo?.mortgageAppliedFor === MortgageType.usda;
  const sortedOrderLogs = aus.orderLogs ? [...aus.orderLogs].sort((a, b) => b.responseTime?.localeCompare(a.responseTime)) : null;
  const orderLogDu = GetLatestDuOrderLog(sortedOrderLogs);
  const orderLogDuEa = GetLatestDuEaOrderLog(sortedOrderLogs);
  const orderLogLpa = GetLatestLpaOrderLog(sortedOrderLogs);
  const lastRun = moment(GetLastRunDate(sortedOrderLogs));
  const isShowLpa = isSandboxLoan && !isShowSandboxLoanLpa ? false : true;

  if (isUSDALoan) {
    card.action = null;
    card.title = `${GetDuStatusHtml(AusResult.NotApplicable)} ${isShowLpa ? `/ ${GetLpaStatusHtml(LpaResult.Incomplete)}` : ''} / ${GetDuEaStatusHtml(AusResult.NotApplicable)}`;
    card.descriptionHtml = `Not Needed: USDA`;
  } else {
    card.title = `${GetDuStatusHtml(orderLogDu?.duResult)} ${isShowLpa ? `/ ${GetLpaStatusHtml(orderLogLpa?.lpaResult)}` : ''} / ${GetDuEaStatusHtml(orderLogDuEa?.duResult)}`;
    if (ausPanelHasBeenOpened && validations?.length > 0) {
      card.descriptionHtml = validations.length === 1 ? '1 Validation' : `${validations.length} Validations`;
    } else if (!orderLogDu && !orderLogLpa && !orderLogDuEa) {
      card.descriptionHtml = `Not Complete`;
    } else {
      card.descriptionHtml = `Last Run <b>${lastRun?.format('M/D/YY')}</b>`;
    }
  }
  return card;
};

export const getDuLpaResult = (
  mortgageAppliedFor: MortgageType,
  orderLogs: OrderLogModel[],
): { duResult: AusResult; lpaResult: LpaResult; eaResult: AusResult } => {
  const isUSDALoan = mortgageAppliedFor === MortgageType.usda;
  const sortedOrderLogs = orderLogs ? [...orderLogs].sort((a, b) => b.responseTime?.localeCompare(a.responseTime)) : null;
  const orderLogDu = GetLatestDuOrderLog(sortedOrderLogs);
  const orderLogLpa = GetLatestLpaOrderLog(sortedOrderLogs);
  const orderLogEa = GetLatestDuEaOrderLog(sortedOrderLogs);

  let duResult = AusResult.Incomplete,
    lpaResult = LpaResult.Incomplete,
    eaResult = AusResult.Incomplete;

  if (!isUSDALoan) {
    duResult = orderLogDu?.duResult ?? duResult;
    lpaResult = orderLogLpa?.lpaResult ?? lpaResult;
    eaResult = orderLogEa?.duResult ?? eaResult;
  }

  return {
    duResult: duResult,
    lpaResult: lpaResult,
    eaResult: eaResult,
  };
};
